import request from '@/utils/request'
const context = require('./context')

export function fetchSysStatus() {
    return request({
        url: context.EEOP + '/sys/loadInfo',
        method: 'get'
    })
}

export function saveSysStatus(params) {
    return request({
        url: context.EEOP + '/sys/statusChange',
        method: 'post',
        data: params
    })
}


// WEBPACK FOOTER //
// ./src/api/sysset.js